/**
 * Main Application Entry Point
 * Initializes all components and manages app state
 */

import { Sidebar } from './components/Sidebar.js';
import { Topbar } from './components/Topbar.js';
import { Dashboard } from './components/Dashboard.js';
import { Transactions } from './components/Transactions.js';
import { Reports } from './components/Reports.js';
import { Router } from './router.js';

class App {
  constructor() {
    this.sidebar = null;
    this.topbar = null;
    this.router = null;
    this.currentModal = null;
  }

  async init() {
    console.log('🚀 Fluxode Caixa v2.0 - Initializing...');

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      await new Promise(resolve => {
        document.addEventListener('DOMContentLoaded', resolve);
      });
    }

    // Create app container structure
    this.setupAppStructure();

    // Initialize components
    this.initializeSidebar();
    this.initializeTopbar();
    this.initializeRouter();

    // Initialize Cloudflare Sync if available
    if (window.CloudflareSync) {
      console.log('📡 Initializing Cloudflare D1 Sync...');
      window.CloudflareSync.init();
    }

    // Expose app globally for debugging and component communication
    window.app = this;

    console.log('✅ App initialized successfully');
  }

  setupAppStructure() {
    const appContainer = document.getElementById('app');
    if (!appContainer) {
      console.error('❌ App container #app not found!');
      return;
    }

    appContainer.innerHTML = `
      <aside class="sidebar" id="sidebar"></aside>
      <div class="main-content">
        <header class="topbar" id="topbar"></header>
        <main class="view-container" id="view-container"></main>
      </div>
    `;
  }

  initializeSidebar() {
    const sidebarContainer = document.getElementById('sidebar');
    if (sidebarContainer) {
      this.sidebar = new Sidebar(sidebarContainer);
      this.sidebar.render();
    }
  }

  initializeTopbar() {
    const topbarContainer = document.getElementById('topbar');
    if (topbarContainer) {
      this.topbar = new Topbar(topbarContainer);
      this.topbar.render();

      // Set callbacks
      this.topbar.setSearchCallback((query) => this.handleGlobalSearch(query));
      this.topbar.setNewTransactionCallback(() => this.openNewTransactionModal());
    }
  }

  initializeRouter() {
    const viewContainer = document.getElementById('view-container');
    if (viewContainer) {
      this.router = new Router(viewContainer, this.sidebar);

      // Register views
      this.router.registerView('dashboard', Dashboard);
      this.router.registerView('transactions', Transactions);
      this.router.registerView('reports', Reports);
      // TODO: Register other views as they're implemented
      // etc.

      // Start router
      this.router.start();
    }
  }

  handleGlobalSearch(query) {
    console.log('🔍 Global search:', query);
    // TODO: Implement global search
    // For now, navigate to transactions view with search parameter
    if (query) {
      this.router.navigate(`/transactions?search=${encodeURIComponent(query)}`);
    }
  }

  openNewTransactionModal() {
    console.log('➕ Opening new transaction modal...');
    // TODO: Implement modal
    // For now, use the old modal from app.js
    if (typeof openModal === 'function') {
      openModal();
    } else {
      alert('Modal de novo lançamento será implementado na Fase 3');
    }
  }

  updateSyncStatus(status, text) {
    if (this.topbar) {
      this.topbar.updateSyncStatus(status, text);
    }
  }
}

// Create and initialize app
const app = new App();
app.init();

// Export for use in other modules
export default app;
